<template>
  <div>
    <label v-if="label" v-bind="labelBindings">{{ label }}</label>
    <input type="file" v-bind="inputBindings" v-on="inputEvents">
    <p v-if="invalid" class="text-danger">{{ errorMessage }}</p>
  </div>
</template>
<script>
import BaseInput from './BaseInput'

export default {
  extends: BaseInput,

  methods: {
    onInput (event) {
      return this.$emit('input', event.target.files)
    }
  },

  computed: {
    inputBindings() {
      return {
        id: this.id,
        'class': 'form-control mb-2'
      }
    },
  }
}
</script>